import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled, { DefaultThemeProps, css } from 'styled-components';

const StandardEquipmentStyles = ({ theme }: DefaultThemeProps) => css`
	margin-bottom: ${pxToRem(theme.spacing['100'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		margin-bottom: ${pxToRem(theme.spacing['400'])};
	}
`;

export const StandardEquipmentContainer = styled.div`
	${StandardEquipmentStyles}
`;
